// MutualFollows
export const companyFollowers = state => state.companyFollowers;
export const companyFollowersPage = state => state.companyFollowersPage;
export const companyFollowersError = state => state.companyFollowersError;
export const companyFollowersLoading = state => state.companyFollowersLoading;
